import React, {useState} from 'react';
import styled from "styled-components";
import moment from "moment/moment";
import {FieldType, Primitive} from "../../../../../Types";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    name: string,
    type: FieldType,
    datetimeFormat?: string
}


function RawEditDatetime({value, onChange, name, type, datetimeFormat}: PropsI) {

    let [newValue, setNewValue] = useState<string>((() => {
        try {
            if (value === null)
                return ''
            if (type === 'datetime')
                return moment(value).locale('en').format('yyyy-MM-DDTHH:mm');
            if (type === 'date')
                return moment(value).locale('en').format('yyyy-MM-DD');
            if (type === 'time')
                return moment(value, [moment.ISO_8601, datetimeFormat ?? 'HH:mm'])
                    .format("HH:mm");
            return ''
        } catch (e) {
            return ''
        }
    })());

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewValue(e.currentTarget.value);
    };

    return <Container>
        <div className="wrapper">
            <input type={type === 'datetime' ? 'datetime-local' : type} className="edit-input-datetime"
                   value={newValue}
                   onBlur={() => onChange(newValue)}
                   onChange={onChangeHandler}/>
        </div>
    </Container>
}

export default RawEditDatetime;

const Container = styled.div`

    & .wrapper {
        display: flex;
        gap: .5rem;
        justify-content: start;
    }

    & input {
        font-size: 1rem;
        text-indent: 0;
    }


`

